import { CheckGreen } from "src/assets";
import { useTranslation } from "react-i18next";
import Text from "src/components/Displays/Text";
import officina from "src/fonts/officina.woff2";
import { useSearchParams } from "react-router-dom";
import PrimaryButton from "src/components/Shared/PrimaryButton";
import { useSessionStorage } from "src/hooks/useSessionStorage";
import { Box, List, ListItem, Stack } from "@mui/material";
import { MicroFrontendDetails, SESSION_KEYS } from "src/consts/session";

const Success = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const manufacturer = searchParams.get("manufacturer") || "";
  const model = searchParams.get("model") || "";

  const [getSessionStorageItem] = useSessionStorage<MicroFrontendDetails>(
    SESSION_KEYS.MICRO_FRONTEND_DETAILS,
  );

  const handleSubmit = () => {
    const sessionData = getSessionStorageItem();
    if (sessionData) {
      window.location.href = sessionData?.callbackUrlSuccess;
    }
  };

  return (
    <Stack gap={5}>
      <Stack alignItems={"start"}>
        <CheckGreen />
      </Stack>

      <Text
        text={t("page.addEvSuccess.pageTitle")}
        sx={(theme) => ({
          fontSize: "32px",
          fontWeight: "500",
          lineHeight: "40px",
          color: "#317D5B",
          fontFamily: "officina",
          "@font-face": {
            fontFamily: "officina",
            src: `url(${officina}) format("woff2")`,
          },
        })}
      />

      <Text
        text={t("page.addEvSuccess.pageSubTitle")}
        sx={(theme) => ({
          fontSize: "14px",
          fontWeight: "400",
          lineHeight: "20px",
          fontFamily: "Inter",
        })}
      />

      <Box
        sx={(theme) => ({
          px: "16px",
          borderRadius: "12px",
          bgcolor: theme.palette.white.main,
        })}
      >
        <List>
          <ListItem
            disablePadding
            disableGutters
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "stretch",
            }}
          >
            <Stack
              width={"100%"}
              direction={"row"}
              alignItems={"center"}
              justifyContent={"space-between"}
              sx={{ padding: "8px 16px" }}
            >
              <Text
                text={t("page.addEvSuccess.manufacturer")}
                sx={(theme) => ({
                  fontSize: "14px",
                  fontWeight: "400",
                  lineHeight: "20px",
                  fontFamily: "Inter",
                  color: theme.palette.black[50],
                })}
              />

              <Text
                text={manufacturer}
                sx={(theme) => ({
                  fontSize: "14px",
                  fontWeight: "400",
                  lineHeight: "20px",
                  fontFamily: "Inter",
                  color: theme.palette.black[50],
                })}
              />
            </Stack>
            <Box
              aria-hidden="true"
              sx={{
                borderBottom: "1px solid",
                borderColor: "divider",
                m: "16px",
              }}
            />
          </ListItem>

          <ListItem>
            <Stack
              width={"100%"}
              direction={"row"}
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <Text
                text={t("page.addEvSuccess.model")}
                sx={(theme) => ({
                  fontSize: "14px",
                  fontWeight: "400",
                  lineHeight: "20px",
                  fontFamily: "Inter",
                  color: theme.palette.black[50],
                })}
              />

              <Text
                text={model}
                sx={(theme) => ({
                  fontSize: "14px",
                  fontWeight: "400",
                  lineHeight: "20px",
                  fontFamily: "Inter",
                  color: theme.palette.black[50],
                })}
              />
            </Stack>
          </ListItem>
        </List>
      </Box>

      <PrimaryButton
        onClick={handleSubmit}
        text={t("page.siteAuthenticationSuccess.nextButton")}
        sx={(theme) => ({
          fontSize: "14px",
          lineHeight: "20px",
          maxWidth: { sm: "320px" },
          color: theme.palette.mainFont.primary,
        })}
      />
    </Stack>
  );
};

export default Success;
